@if (trialBannerService.showTrialBanner()) {
  <div class="trial-banner" [class.trial-banner--urgent]="trialBannerService.isUrgent()">
    <div class="trial-banner__content">
      @if (trialBannerService.isUrgent()) {
        <ng-icon class="trial-banner__icon" name="iconoirWarningTriangle" size="20" />
      } @else {
        <ng-icon class="trial-banner__icon" name="iconoirRocket" size="20" />
      }
      <span class="trial-banner__text">
        @if (trialBannerService.isUrgent()) {
          Votre essai se termine dans
          <strong>{{ trialBannerService.daysRemaining() }} jour{{ trialBannerService.daysRemaining() === 1 ? '' : 's' }}</strong>.
          Choisissez votre offre pour continuer à utiliser Mokah+.
        } @else {
          Plus que
          <strong>{{ trialBannerService.daysRemaining() }} jours</strong>
          d'essai gratuit : choisissez votre offre pour garder vos données et votre équipe.
        }
      </span>
    </div>
    <a routerLink="/admin/subscription/plans" class="trial-banner__cta">
      <app-btn
        [config]="{
          type: 'filled',
          color: 'coffee',
          size: 'small'
        }"
      >
        Choisir mon offre
      </app-btn>
    </a>
    @if (trialBannerService.canDismiss()) {
      <button type="button" class="trial-banner__close" (click)="trialBannerService.dismissForToday()"
        aria-label="Masquer ce rappel jusqu'à demain" title="Masquer jusqu'à demain">
        <ng-icon name="iconoirXmark" size="18" aria-hidden="true" />
      </button>
    }
  </div>
}
